import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { MapBackgroundKind } from '../lib/foxhole-maps.js';

export type MapBackground = MapBackgroundKind;

export interface PersistedViewport {
  cx: number;
  cy: number;
  scale: number;
}

interface MapViewState {
  mapBackground: MapBackground;
  showGrid: boolean;
  showSubregions: boolean;
  viewport: PersistedViewport | null;
  setMapBackground: (bg: MapBackground) => void;
  /** Toggles the "Ink & Frontline" easter-egg background on/off, always reverting to `default` when disabled. */
  toggleInkBackground: () => void;
  toggleGrid: () => void;
  toggleSubregions: () => void;
  setViewport: (v: PersistedViewport) => void;
}

export const useMapView = create<MapViewState>()(
  persist(
    (set) => ({
      mapBackground: 'imm',
      showGrid: true,
      showSubregions: true,
      viewport: null,
      setMapBackground: (bg) => set({ mapBackground: bg }),
      toggleInkBackground: () =>
        set((s) => ({ mapBackground: s.mapBackground === 'ink' ? 'default' : 'ink' })),
      toggleGrid: () => set((s) => ({ showGrid: !s.showGrid })),
      toggleSubregions: () => set((s) => ({ showSubregions: !s.showSubregions })),
      setViewport: (v) => set({ viewport: v }),
    }),
    {
      name: 'warplan.map-view',
      partialize: (s) => ({
        mapBackground: s.mapBackground,
        showGrid: s.showGrid,
        showSubregions: s.showSubregions,
        viewport: s.viewport,
      }),
    },
  ),
);

